import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, LOGO_WHITE, LOGO_BLUE, openWhatsApp } from "@/data/content";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dark = scrolled;

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        dark ? "bg-white/95 backdrop-blur-md shadow-sm py-3" : "bg-transparent py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <a href="#inicio" data-testid="logo" className="flex items-center">
          <img
            src={dark ? LOGO_BLUE : LOGO_WHITE}
            alt="Bahia Gás"
            className="h-11 lg:h-12 w-auto object-contain"
          />
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={`text-sm font-semibold transition-colors hover:text-[#1d3fd9] ${
                  dark ? "text-[#0f1733]" : "text-white/90 hover:text-white"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-5">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="navbar-phone"
            className={`flex items-center gap-2 text-sm font-semibold ${dark ? "text-[#0f1733]" : "text-white"}`}
          >
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
          <button
            data-testid="navbar-cta"
            onClick={() => openWhatsApp()}
            className="bg-[#a3e635] hover:bg-[#92d420] text-[#0f1733] font-bold text-sm px-6 py-3 rounded-2xl shadow-lg shadow-[#a3e635]/30 transition-all hover:-translate-y-0.5"
          >
            Peça Agora
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden ${dark ? "text-[#0f1733]" : "text-white"}`}
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t mt-3 px-5 py-4 shadow-xl">
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block py-2.5 text-[#0f1733] font-semibold"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <button
            onClick={() => { setOpen(false); openWhatsApp(); }}
            className="mt-3 w-full bg-[#a3e635] text-[#0f1733] font-bold py-3 rounded-2xl"
          >
            Peça Agora
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
